module.exports = __webpack_public_path__ + "img/w61.fb3c17b4.svg";